import { render, staticRenderFns } from "./draggable-list.vue?vue&type=template&id=b8c5c906&scoped=true&"
import script from "./draggable-list.vue?vue&type=script&lang=js&"
export * from "./draggable-list.vue?vue&type=script&lang=js&"
import style0 from "./draggable-list.vue?vue&type=style&index=0&id=b8c5c906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c5c906",
  null
  
)

export default component.exports